import * as Yup from "yup"

export const FIELDS_NAME = {
   NAME: "name",
   START_DATE: "startDate",
   END_DATE: "endDate",
   STATUS: "status",
   SLOT_SEQUENCE_NUMBER: "startingSlotId",
}

export const TOMORROW_DATE = (() => {
   const tomorrow = new Date()
   tomorrow.setDate(tomorrow.getDate() + 1)
   tomorrow.setHours(0, 0, 0, 0)
   return tomorrow
})()

export const initialValues = {
   [FIELDS_NAME.NAME]: "",
   [FIELDS_NAME.START_DATE]: TOMORROW_DATE,
   [FIELDS_NAME.END_DATE]: null,
   [FIELDS_NAME.STATUS]: "INACTIVE",
   [FIELDS_NAME.SLOT_SEQUENCE_NUMBER]: 0,
}

export const getValidationSchema = id => {
   const baseSchema = {
      [FIELDS_NAME.NAME]: Yup.string()
         .required("Production Line Name is required")
         .min(1, "Name must be at least 1 characters")
         .max(1000, "Name can't be more than 1000 characters"),
      [FIELDS_NAME.STATUS]: Yup.string().required("Select status"),
      [FIELDS_NAME.SLOT_SEQUENCE_NUMBER]: Yup.number()
         .required("Slot sequence number is required")
         .min(1, "Slot sequence number must be at least 1")
         .integer("Slot sequence number must be a whole number"),
   }

   if (!id) {
      baseSchema[FIELDS_NAME.START_DATE] = Yup.date()
         .nullable()
         .typeError("Please provide a valid date.")
         .required("Select a publish date")
   }
   baseSchema[FIELDS_NAME.END_DATE] = Yup.date()
      .nullable()
      .typeError("Please provide a valid end date.")
      .when(FIELDS_NAME.START_DATE, (startDate, schema) => {
         return startDate
            ? schema.min(startDate, "End date must be after start date")
            : schema
      })

   return Yup.object(baseSchema)
}
